export {};

declare global {
    interface Window {
        axios: any;
    }
}

export enum ResponseError {
    Unknown = 0,
    Validation = 1,
    Unauthorized = 2,
    NotFound = 3,
    Internal = 4,
    TooLarge = 5,
    Network = 6,
}

export enum PaymentSystem {
    Visa = "visa",
    MasterCard = "mc"
}

export enum AlertType {
    success = "success",
    error = "error",
    warning = "warning",
    info = "info"
}